import { g as t } from "../internals/get-built-in.js";
import { w as s } from "../internals/well-known-symbol-define.js";
import { s as n } from "../internals/set-to-string-tag.js";
s("toStringTag"), n(t("Symbol"), "Symbol");